<template>
    <div>
        <report-header
            :title="title"
            :isShowDateRange="true"
            :formatDateRangeTitle="dateRange"
        />
        <b-card id="report-card">
            <div id="report-body" class="w-100">
                <QTable
                    :columns="columns"
                    :data="detail"
                    :hide-bottom="true"
                    :rows-per-page-options="[0]"
                    :loading="loaded"
                    class="q-table"
                >
                    <template
                        v-slot:bottom-row
                        v-if="detail.length === 0 && !loaded"
                    >
                        <q-tr>
                            <q-td colspan="10" align="center">
                                {{
                                    isShowDateRange
                                        ? "No records available"
                                        : "Please select the filter"
                                }}.
                            </q-td>
                        </q-tr>
                    </template>
                    <template v-slot:body-cell-credit_id="props">
                        <q-td :props="props">
                            Credit #{{ props.row.credit_id }}
                        </q-td>
                    </template>
                    <template v-slot:body-cell-client="props">
                        <q-td :props="props">
                            <client-name
                                :client="{
                                    encoded_id: props.row.clientEncodedId,
                                    name: props.row.client
                                }"
                            />
                        </q-td>
                    </template>
                    <template v-slot:body-cell-applied_by="props">
                        <q-td :props="props">
                            <client-name
                                :client="{
                                    encoded_id: props.row.appliedByEncodedId,
                                    name: props.row.applied_by
                                }"
                            />
                        </q-td>
                    </template>
                    <template v-slot:body-cell-invoice_id="props">
                        <q-td :props="props">
                            <a
                                class="text-capitalize"
                                :href="
                                    props.row.invoiceEncodedId
                                        ? env.APPS +
                                          'billing/invoice/view/' +
                                          props.row.invoiceEncodedId
                                        : ''
                                "
                            >
                                Invoice #{{ props.row.invoice_id }}
                            </a>
                        </q-td>
                    </template>
                </QTable>
            </div>
        </b-card>
    </div>
</template>
<script>
import { QTable } from "quasar";
import "@/css/quasar-table.css";
import Report from "@/mixins/report.js";
import ReportService from "@/services/report";
import CREPORT from "@/constants/report";
import ClientName from "@/components/commons/client-name";
export default {
    components: {
        QTable,
        ClientName,
        ReportHeader: () => import("@/components/report/report-header")
    },
    mixins: [Report],
    props: {
        data: {
            type: Object,
            default() {
                return {
                    start: this.getStartDate("day"),
                    end: this.getStartDate("day"),
                    datePickerOptions: {
                        format: this.datepickerFormat
                    },
                    ignoreFormat: 1
                };
            }
        }
    },
    data() {
        return {
            locale: "en-US",
            meta: "",
            params: "",
            code: "",
            dateRange: "",
            detail: [],
            loaded: false,
            isShowDateRange: false,
            title: "Credits Applied",
            columns: [
                {
                    name: "credit_id",
                    field: "credit_id",
                    label: "Credit",
                    align: "left",
                    style: "white-space: nowrap"
                },
                {
                    name: "creditCreateDate",
                    field: "credit_date",
                    label: "Date",
                    align: "left",
                    style: "white-space: nowrap"
                },
                {
                    name: "invoice_id",
                    field: "invoice_id",
                    label: "Invoice",
                    align: "left",
                    style: "white-space: nowrap"
                },
                {
                    name: "client",
                    field: "client",
                    label: "Client",
                    align: "left",
                    style: "white-space: nowrap"
                },
                {
                    name: "amount",
                    field: "amount",
                    label: "Amount",
                    align: "left",
                    style: "white-space: nowrap"
                },
                {
                    name: "balance",
                    field: "balance",
                    label: "Balance",
                    align: "left",
                    style: "white-space: nowrap"
                },
                {
                    name: "note",
                    field: "note",
                    label: "Notes",
                    align: "left",
                    style: "width: 25%"
                },
                {
                    name: "applied_by",
                    field: "applied_by",
                    label: "Applied By",
                    align: "left",
                    style: "white-space: nowrap"
                },
                {
                    name: "applied_dt",
                    field: "applied_dt",
                    label: "Applied Date",
                    align: "left",
                    style: "white-space: nowrap"
                }
            ]
        };
    },
    mounted() {
        let self = this;
        self.data.isShowDateRange = true;
        self.data.start = self.getStartDate("week");
        self.data.end = self.getEndDate("day");
        self.data.from = self.converToUnix(self.data.start);
        self.data.to = self.converToUnix(self.data.end);
        self.data.datePickerOptions.format = this.getDateFormat();
        self.init();
        self.$root.$on("report-filter-date-range:refresh", function (params) {
            self.init(params);
        });
        self.$root.$on("credits-applied:refresh", function () {
            self.refresh = 1;
            self.init();
        });
    },
    beforeDestroy: function () {
        let self = this;
        this.$root.$off("report-filter-date-range:refresh", function (params) {
            self.init(params);
        });
        this.$root.$off("credits-applied:refresh");
    },
    methods: {
        async init(params) {
            let self = this;
            self.isShowDateRange = true;
            self.loaded = true;
            let reportParams = {
                from: params ? params.from : self.data.start.unix(),
                to: params ? params.to : self.data.end.unix(),
                refresh: self.refresh
            };
            self.refresh = null;
            self.dateRange = self.getDateRange(self.data.from, self.data.to);
            await ReportService.getReport(
                CREPORT.TYPE.CREDITS_APPLIED,
                reportParams
            )
                .then(response => {
                    if (
                        response &&
                        response.message &&
                        response.message.code === 200
                    ) {
                        self.loaded = false;
                        self.code = response.status;
                        self.meta = response.resource.meta;
                        self.detail = response.resource.results;
                        self.title = self.capitalize(self.meta.title);
                    } else if (response.queue) {
                        self._message(response.message, "warning");
                    }
                })
                .catch(e => {
                    console.error(e);
                    self._message("Error: Unable to get the report.", "danger");
                    self.loaded = true;
                })
                .finally(() => {
                    self.loaded = false;
                });
        },
        formatDateRangeTitle() {
            if (this.data.start && this.data.end) {
                return (
                    this.data.start.format(this.getDateFormat()) +
                    " - " +
                    this.data.end.format(this.getDateFormat())
                );
            }
            return null;
        }
    }
};
</script>
